import React from "react";
import _ from "lodash";

import IColumn from "models/IColumn";
import { getFormatted } from "helpers/formatting";
import { downloadDocument } from "helpers/download";
import { PictureAsPdf } from "components/Icons";

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    key: "pdf",
    isSortable: false,
    fixedWidth: 52,
    render: rowData => (
      <PictureAsPdf
        id={`download-delivery-notes-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(rowData);
        }}
      />
    ),
    visible: true,
    notRowClick: true
  },
  {
    title: "ORDERS_NUMBER",
    fixedWidth: 128,
    key: "Order.Number",
    visible: true
  },
  {
    title: "DELIVERIES_BUYER_NR",
    key: "Order.Buyer.Number",
    visible: true
  },
  {
    title: "DELIVERIES_PLANNED_DATE",
    key: "Order.DeliveryPeriodEnd",
    type: "date",
    visible: true
  },
  {
    title: "ARTICLE_DESCRIPTION",
    key: "Item.Description",
    render: rowData =>
      _.get(rowData, "Item.Description") + _.get(rowData, "GrowerClaims", ""),
    visible: true
  },
  {
    title: "SIZE",
    key: "ProductValue1.Description",
    visible: true
  },
  {
    title: "HARVEST_YEAR",
    key: "Order.HarvestYear",
    visible: true
  },
  {
    title: "PRICE",
    key: "Price",
    render: rowData =>
      rowData.Price && rowData.RoleId !== "Supplier"
        ? getFormatted(rowData.Price, "currency")
        : "-",
    type: "currency",
    visible: true
  },
  {
    title: "PRICE_UNIT",
    key: "PriceUnit.Description",
    render: rowData =>
      rowData.PriceUnit.Description && rowData.RoleId !== "Supplier"
        ? rowData.PriceUnit.Description
        : "-",
    visible: true
  },
  {
    title: "DELIVERIES_SOLD",
    key: "Quantity",
    type: "absolute",
    visible: true
  },
  {
    title: "QUANTITY_UNIT",
    key: "QuantityUnit.Description",
    visible: true
  },
  {
    title: "DELIVERIED_QUANTITY",
    key: "TotalDelivered",
    isSortable: false,
    render: rowData =>
      getFormatted(
        _.get(rowData, "ShippedQuantity", 0) +
          _.get(rowData, "PendingQuantity", 0),
        "number"
      ),
    visible: true
  },
  {
    title: "BIO",
    key: "Bio",
    type: "boolean",
    visible: true
  },
  {
    title: "DELIVERIES_COMPLETE",
    key: "ShippedCompletely",
    type: "boolean",
    visible: true
  },
  {
    title: "DELIVERIES_ADDRESS",
    key: "Order.DeliveryAddressIsAlternative",
    type: "boolean",
    visible: true
  },
  {
    title: "ORDERS_LINE_NR",
    key: "Number",
    visible: true
  },
  {
    title: "DELIVERIES_CULTIVAR",
    key: "Item.CultivarDescription",
    visible: false
  }
];
